// Unified item categories — single source of truth for the four canonical item types.
// Raw Material (blue) · Brought Out (yellow) · Mfg. Spares (purple) · Manufactured (green)
export const ITEM_TYPES = [
  { value: "raw", label: "Raw Material", badge: "bg-blue-100 text-blue-700" },
  { value: "spare", label: "Brought Out", badge: "bg-yellow-100 text-yellow-700" },
  { value: "mfg_spare", label: "Mfg. Spares", badge: "bg-purple-100 text-purple-700" },
  { value: "manufactured", label: "Manufactured", badge: "bg-emerald-100 text-emerald-700" },
];

export const TYPE_LABEL = Object.fromEntries(ITEM_TYPES.map((t) => [t.value, t.label]));
export const TYPE_BADGE = Object.fromEntries(ITEM_TYPES.map((t) => [t.value, t.badge]));
export const typeLabel = (t) => TYPE_LABEL[t] || "Raw Material";
export const typeBadge = (t) => TYPE_BADGE[t] || TYPE_BADGE.raw;
